<template>
  <div class="tableStyle">
    <div class="tableBox">
      <div class="tableStyle-left">
        <div  v-show="stateArrow" id="leftBox" class="leftBox" style="width: 206px">
          <vue-draggable-resizable
          style="height: 100%"
          :min-width="160"
          @resizing="onResize"
          :max-width="400"
          :draggable="false"
          :handles="['mr']"
          :w="206"
          :parent="false"
        >
        <div class="carInsBtn">
            <el-row>
              <el-col class="carInsHeadLeft" :span="12">
                <span>{{$t('NavMenu.ReportPush')}}</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col style="text-align: center" :span="24">
                <el-input
                  @keyup.enter.native="getBrand"
                  class="smallInput"
                  size="mini"
                  v-model="searchValue"
                  :placeholder="$t('common.searchTip')"
                ></el-input>
              </el-col>
            </el-row>
          </div>
          <div style="height: calc(100% - 97px)" class="carInsList">
            <el-scrollbar>
              <el-radio-group
                @change="ChangModel"
                style="width: 100%"
                v-model="taskId"
              >
                <el-radio
                  v-for="item in BrandList"
                  :key="item.id"
                  :label="item.id"
                  >{{ item.name }}</el-radio
                >
              </el-radio-group>
            </el-scrollbar>
          </div>
        </vue-draggable-resizable>
        </div>
        <div class="leftCaret" @click="changeArrow">
          <i :class="stateArrow ? 'el-icon-caret-left' : 'el-icon-caret-right'"></i>
        </div>
      </div>
      <div class="tableStyle-right">
        <div class="carStateTable">
          <el-scrollbar>
            <div class="rightAll">
              <div class="rightAll-form">
                <el-form
                  :inline="true"
                  :model="formInline"
                  class="demo-form-inline"
                >
                  <el-form-item>
                    <el-select
                      class="carSelect"
                      size="small"
                      v-model="formInline.filterItem"
                      clearable
                      :placeholder="$t('common.choseTip')"
                    >
                      <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                    <el-input
                      class="carInput"
                      size="small"
                      v-model="formInline.filterParam"
                      :placeholder="$t('common.contextTip')"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button
                      size="mini"
                      type="primary"
                      @click="onSearch"
                      class="btn-chaxun"
                      >{{$t('common.btn.search')}}</el-button
                    >
                    <el-button size="mini" @click="onClear" class="btn-del"
                      >{{$t('common.btn.cancel')}}</el-button
                    >
                  </el-form-item>
                </el-form>
              </div>
              <i-table
                :list="list"
                :height="height"
                ref="carTable"
                @handleSelectionChange="handleSelectionChange"
                :options="option"
                :columns="columns"
                :operates="operates"
              ></i-table>
              <IPagination ref="page" @PageFun="changeSize"></IPagination>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <el-dialog
        :title="$t('common.btn.operate')"
        :visible.sync="dialogVisible"
        width="30%"
        :before-close="handleClose"
        class="addDialong"
        :close-on-click-modal="false"
      >
        <el-radio-group v-model="radio">
          <el-radio :label="1">{{$t('PlatformSettings.dailyReport')}}</el-radio>
          <el-radio :label="2">{{$t('PlatformSettings.weekReport')}}</el-radio>
          <el-radio :label="3">{{$t('PlatformSettings.monthReport')}}</el-radio>
          <el-radio :label="4">{{$t('PlatformSettings.dailyMonthReport')}}</el-radio>
        </el-radio-group>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" class="btn-del" @click="dialogVisible = false"
            >{{$t('common.btn.cancel')}}</el-button
                >
          <el-button
            size="small"
            class="btn-que"
            type="primary"
            @click="changeSwitch()"
            >{{$t('common.btn.confirm')}}</el-button
                >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import ReportPush from "./ReportPush.js";
export default ReportPush;
</script>

<style lang="less" scoped>
@import "../../../assets/styles/Style.less";
</style>
